exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, "@keyframes progress{0%{background-position:-200px 0}100%{background-position:calc(200px + 100%) 0}}.react-loading-skeleton{animation:progress 1.2s ease-in-out infinite;background-color:#eee;background-image:linear-gradient(90deg, #eee, #f5f5f5, #eee);background-size:200px 100%;background-repeat:no-repeat;border-radius:4px;display:inline-block;line-height:1;width:100%}.imagen{height:100px;width:100px}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/sass-loader/dist/cjs.js!./src/components/Skeleton/style.scss
// module id = 1774
// module chunks = 33